import { render, staticRenderFns } from "./ButtonIconText.vue?vue&type=template&id=0dc7e264&scoped=true&"
import script from "./ButtonIconText.vue?vue&type=script&lang=js&"
export * from "./ButtonIconText.vue?vue&type=script&lang=js&"
import style0 from "./ButtonIconText.vue?vue&type=style&index=0&id=0dc7e264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc7e264",
  null
  
)

export default component.exports